import styled from "styled-components";

/**
 * @typedef {{
 * size: number | string;
 * bg: string;
 * borderColor: string;
 * contain: string;
 * }} ImageWrapperProps
 */

const ImgWrapper =
  /** @type {import('styled-components').ThemedStyledFunction<'div', ImageWrapperProps>} */
  (styled.div)`
    height: ${(props) => props.size ?? "4.8"}rem;
    width: ${(props) => props.size ?? "4.8"}rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    background-color: ${(props) => props.bg ?? "var(--primary)"};
    border: ${(props) =>
      props.borderColor ? `1px solid ${props.borderColor}` : "none"};
    flex-shrink: 0;
    position: relative;

    img {
      height: 100%;
      width: 100%;
      object-fit: ${(props) => (props.contain ? `contain` : "cover")};
    }

    .loader {
      position: absolute;
      width: 20px;
      height: 20px;
    }
  `;

export default ImgWrapper;
